var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cont_cafe", attrs: { id: "daumContent" } }, [
    _c(
      "article",
      { staticClass: "apply_list", attrs: { id: "mArticle" } },
      [
        _c(
          "apply-list-info",
          _vm._b({}, "apply-list-info", _vm.propsToInfo, false)
        ),
        _vm._v(" "),
        _c("p", { staticClass: "box_desc" }, [
          _c("em", { staticClass: "apply_article_total" }, [
            _vm._v(_vm._s(_vm.articleCount.toLocaleString()))
          ]),
          _vm._v("명이 참여하였습니다.")
        ]),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "list_applicant",
            class: { list_type2: _vm.isMore },
            attrs: { id: "apply_list" }
          },
          [
            _vm.info.type === "apply"
              ? _vm._l(_vm.articleList, function(article, index) {
                  return _c(
                    "li",
                    { key: index, attrs: { "data-dataid": article.dataid } },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "link_applicant",
                          attrs: { href: _vm.articleLinkBy(article.dataid) }
                        },
                        [
                          _c("span", { staticClass: "txt_nickname" }, [
                            _c("strong", [
                              _vm._v(_vm._s(article.writer.nickName))
                            ]),
                            _vm._v(" 님이 참여하였습니다.")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "wrap_info" }, [
                            _c("time", { staticClass: "txt_date" }, [
                              _vm._v(_vm._s(article.applydate))
                            ]),
                            _vm._v(" "),
                            article.hasReply
                              ? _c("span", { staticClass: "txt_replay" }, [
                                  _vm._v("답변 1")
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ]
                  )
                })
              : _vm._l(_vm.articleList, function(article, index) {
                  return _c(
                    "li",
                    { key: index, attrs: { "data-dataid": article.dataid } },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "link_applicant",
                          attrs: { href: _vm.articleLinkBy(article.dataid) }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "txt_nickname",
                              class: article.status
                            },
                            [
                              article.writer.private
                                ? _c("span", [
                                    _c("strong", [
                                      _vm._v(
                                        "[" +
                                          _vm._s(
                                            _vm.statusToKorean(article.status)
                                          ) +
                                          "]"
                                      )
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(article.writer.nickName) +
                                        "(비공개)\n                            "
                                    )
                                  ])
                                : article.writer.exist
                                ? _c("span", [
                                    _c("strong", [
                                      _vm._v(
                                        "[" +
                                          _vm._s(
                                            _vm.statusToKorean(article.status)
                                          ) +
                                          "]"
                                      )
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(article.writer.nickName) +
                                        "(" +
                                        _vm._s(article.writer.email) +
                                        ")\n                            "
                                    )
                                  ])
                                : _c("span", [
                                    _c("strong", [
                                      _vm._v(
                                        "[" +
                                          _vm._s(
                                            _vm.statusToKorean(article.status)
                                          ) +
                                          "]"
                                      )
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(article.writer.nickName) +
                                        "\n                            "
                                    )
                                  ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "wrap_info" }, [
                            _c("time", { staticClass: "txt_date" }, [
                              _vm._v(_vm._s(article.applydate))
                            ]),
                            _vm._v(" "),
                            article.hasReply
                              ? _c("span", { staticClass: "txt_replay" }, [
                                  _vm._v("답변 1")
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ]
                  )
                })
          ],
          2
        ),
        _vm._v(" "),
        _vm.isMore
          ? _c(
              "button",
              {
                staticClass: "btn_applicant",
                attrs: { type: "button", id: "btn_list_more" },
                on: { click: _vm.getApplyList }
              },
              [_c("span", { staticClass: "ico_cafe" }, [_vm._v("더보기")])]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }